import { Injectable } from '@angular/core';
import { DailyOtCardItem } from './daily-ot-card/daily-ot-card.component';
import moment from 'moment';
import { TourneeProvider } from '../../../providers/activites/tournee.provider';
import { OtResponse } from '../../../../api/models/ot-response';
import { LocalisationResponse } from '../../../../api/models/localisation-response';

@Injectable({
  providedIn: 'root',
})
export class DailyOtsService {
  constructor(private tourneeProvider: TourneeProvider) {}

  async getDailyOt(idUser: string): Promise<DailyOtCardItem[]> {
    let plan_date_debut = moment().startOf('day').toISOString();
    let plan_date_fin = moment().endOf('day').toISOString();
    const tournee: OtResponse[] = await this.tourneeProvider.getTournee(idUser, false, plan_date_debut, plan_date_fin);
    if (tournee) {
      return this.filterSortAndMapDailyOts(tournee);
    }
    return [];
  }

  filterSortAndMapDailyOts(tournee: OtResponse[]) {
    return this.filterOts(tournee)
      .sort((a, b) => {
        return new Date(a.planification_date_debut).getTime() - new Date(b.planification_date_debut).getTime();
      })
      .map((value) => {
        return this.mapToDailyOtCardItem(value);
      });
  }

  /**
   * Filter OTs to only keep today's and remove Ots with unknow sites.
   */
  private filterOts(tournee: OtResponse[]): OtResponse[] {
    let filteredArray = new Array<OtResponse>();
    let filteredId = new Array<string>();
    tournee.forEach((ot) => {
      if (filteredId.indexOf(ot.id_ot) === -1) {
        let day_selected = moment().add('1', 'second');
        let a = moment(ot.planification_date_debut).startOf('day').format();
        let b = moment(ot.planification_date_fin).endOf('day').format();
        if (!ot.localisation) {
          ot.localisation = {
            code_localisation: 'code_localisation',
            libelle_long: 'Site inconnu',
          } as LocalisationResponse;
          ot.site = { code_localisation: 'code_localisation', libelle_long: 'Site inconnu' } as LocalisationResponse;
        }
        if (day_selected.isBetween(a, b) && ot.localisation) {
          filteredArray.push(ot);
          filteredId.push(ot.id_ot);
        }
      }
    });
    return filteredArray;
  }

  private mapToDailyOtCardItem(ot: OtResponse): DailyOtCardItem {
    if (ot.site) {
      return {
        site: ot.site.libelle_long,
        idSite: ot.site.id_localisation,
        type: ot.type_activite,
        startTime: this.getTimeFromDateTime(ot.planification_date_debut),
        endTime: this.getTimeFromDateTime(ot.planification_date_fin),
        idOt: ot.id_ot,
        est_rdv_client: ot.est_rdv_client,
        has_echapetbelle: ot.has_echapetbelle,
        numeroOt: ot.numero_ot,
        libelleOt: ot.libelle_intervention,
        est_controle_reglementaire: ot.est_controle_reglementaire,
        presence_document: ot.demande_intervention?.presence_document,
      };
    } else {
      return {
        site: '',
        idSite: '',
        type: ot.type_activite,
        startTime: this.getTimeFromDateTime(ot.planification_date_debut),
        endTime: this.getTimeFromDateTime(ot.planification_date_fin),
        idOt: ot.id_ot,
        numeroOt: ot.numero_ot,
        libelleOt: ot.libelle_intervention,
        est_controle_reglementaire: ot.est_controle_reglementaire,
        presence_document: ot.demande_intervention?.presence_document,
      };
    }
  }

  private getTimeFromDateTime(dateString: string): string {
    const date = new Date(dateString);
    const HH = date.getHours().toString();
    const MM = date.getMinutes().toString();

    return `${HH.padStart(2, '0')}:${MM.padStart(2, '0')}`;
  }
}
